import cacheLs from "../cacheLs"

export default {
  addWelcome (state, data) {
    state.selectedWelcome = { ...data }
    cacheLs.set_welcome(data)
  }
}
